import React, { useState } from 'react';
import { useCommonTranslation } from '../../modules/i18n/hooks/useTranslation';

interface SearchBarProps {
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  onSearch?: (query: string) => void;
  className?: string;
  disabled?: boolean;
}

const SearchBar: React.FC<SearchBarProps> = ({ placeholder, value = '', onChange, onSearch, className = '', disabled = false }) => {
  const { t } = useCommonTranslation();
  const resolvedPlaceholder = placeholder ?? t('search.placeholder');
  const [searchQuery, setSearchQuery] = useState(value);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setSearchQuery(newValue);
    onChange?.(newValue);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSearch?.(searchQuery);
    }
  };

  return (
    <div className={`relative ${className}`}>
      <div className='pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3'>
        <svg className='h-4 w-4 text-gray-400 dark:text-dark-text-secondary' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z' />
        </svg>
      </div>
      <input
        type='text'
        value={searchQuery}
        onChange={handleInputChange}
        onKeyPress={handleKeyPress}
        placeholder={resolvedPlaceholder}
        disabled={disabled}
        className='w-full rounded-lg border border-gray-300 bg-white py-2 pl-10 pr-4 text-sm text-gray-900 placeholder-gray-400 focus:border-primary focus:outline-none focus:ring-primary disabled:cursor-not-allowed disabled:opacity-50 dark:border-border-dark dark:bg-dark-background-tertiary dark:text-dark-text dark:placeholder-dark-text-secondary'
      />
    </div>
  );
};

export default SearchBar;
